import { getAuth, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { getSecondaryFirebaseApp } from './app';

/**
 * Create a Firebase Auth user using a secondary auth instance so we don't
 * log out the currently signed-in owner.
 */
export async function createSecondaryAuthUser({ email, password }) {
    if (!email || !password) throw new Error('Missing email or password');

    const auth = getAuth(getSecondaryFirebaseApp());
    try {
        const cred = await createUserWithEmailAndPassword(auth, email, password);
        // Ensure we don't keep a session around in the secondary auth instance
        await signOut(auth);
        return { uid: cred.user.uid, email: cred.user.email };
    } catch (err) {
        const code = err?.code || 'auth/unknown';
        const msg = err?.message || 'Failed to create auth user';
        throw new Error(`${code}: ${msg}`);
    }
}

